import React from "react";
const helpcanvas = {
  display: 'grid',
  gridTemplateColumns: '2fr 3fr 5fr',
  gridTemplateRows: 'min-content 1fr',
  backgroundColor: "#f2f2f2",
  height: '100vh',
  width: '100%',
  rowGap: '24px',
  columnGap: '14px',
  padding: '0 0 14px 0',
};

const helptitle = {
  color: "#222",
  backgroundColor: "#f2f2f2",
  padding: "2px",
  fontFamily: "Arial",
  fontSize: "13px",
};

const helpimg = {
    color: "#222",
    backgroundColor: "#f2f2f2",
    padding: "2px",
    fontFamily: "Arial",
  };

const UIADSystem = {
    name: 'System Config',
    imageUrl: '../../images/ADSystem.png',
    imageSize: "100%",
    bradius: 20,
  };

const UIADO365 = {
    name: 'Office365 Credentials',
    imageUrl: '../../images/ADO365.png',
    imageSize: "99%",
    bradius: 20,
  };

const UIADGoogle = {
    name: 'Google Credentials',
    imageUrl: '../../images/ADGoogle.png',
    imageSize: "99%",
    bradius: 20,
  };

const UIADNewregex = {
    name: 'Add New Regex',
    imageUrl: '../../images/ADNewregex.png',
    imageSize: "99%",
    bradius: 20,
  };

const UIADUpdateregex = {
    name: 'Update Regex',
    imageUrl: '../../images/ADUpdateregex.png',
    imageSize: "99%",
    bradius: 20,
  };

const UIADKeywords = {
    name: 'Add New Keywords',
    imageUrl: '../../images/ADKeywords.png',
    imageSize: "99%",
    bradius: 20,
  };

export const ADSystem = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>System Config</b><br/><br/>
      These settings can be left default, however, it is best to configure the CYRISMA 
      instance to meet the needs of the organization. A typical system configuration 
      setup may look like this. <br/><br/>
      
      Each of the settings can be adjusted as follows: <br/><br/>
      
      <b>Authentication Type:</b> Cloud-based instances are always set to "Local". <br/>
      Two-Factor Authentication: Login authentication will require a One-Time Passcode 
      (OTP) that will be emailed to the user address on record at each login. <br/>
      Two-Factor Authentication Timeout: Sets the timeout value of the emailed OTP 
      (One-Time Passcode) in hours. <br/>
      <b>Password Expiration:</b> Password use duration - generally 60 days, but can be set 
      to suit local policy requirements. Users receive a password reset reminder email 
      before a password expires. <br/>
      <b>Secure Location:</b> Define the file path to move files to when the mitigation action 
      is "Move to Secure Location". This file path is from the perspective of the agent. 
      It is recommended that a secure location be set up on the network with access 
      granted to CYRISMA agents. When a file is moved (as part of a mitigation plan action) 
      a directory structure is replicated under the secure location path that reflects 
      the path of the original file. Users do not need access to the secure location 
      in order to perform this action, as the agent moves files to this location on 
      behalf of the user. <br/>
      <b>Retention:</b> Maximum Report Retention can be up to 365 days. This can be set to a 
      shorter period to suit local policy requirements. <br/>
      Approval: Cloud-based instances do not use this setting. Currently, no approval 
      is required during mitigation action, no matter what setting is selected here. <br/>
      Risk Grade Span: Either monthly or quarterly, depending on local policy 
      requirements. If monthly, then "previous grade" refers to scans that were 
      completed in the 31 to 60-day window, and "current grade" refers to scans       
      that were completed in the 0 to 30-day window. If quarterly, then "previous 
      grade" refers to scans that were completed in the previous calendar quarter, 
      and "current grade" refers to scans that were completed in the current calendar 
      quarter. <br/>
      <b>Risk Suppress Duration:</b> This global setting applies to Vulnerability Mitigation. 
      Set the number of days (up to 90) that an identified vulnerability risk is suppressed 
      on future scans. An unpatched vulnerability that still exists but is suppressed will 
      not show up in future scan results and grades. This allows time for patch mitigation 
      action to acquire and test patches for production deployment. Once the suppression 
      duration period expires, risks will have to be suppressed again if further suppression 
      is desired. <br/>
      <b>Notification Days:</b> For users that are set to have alerts enabled (such as expiring 
      mitigation plans), this global setting specifies the days of the week that users 
      receive such alerts. <br/>
      <b>Currency Type:</b> Set the currency to the instance’s local value. This allows monetized 
      values to be expressed according to the CYRISMA instance’s local currency. <br/>
      3rd Party Credentials: In cases where data sensitivity scans include cloud-based       
      locations (such as Microsoft OneDrive, or email hosted in Exchange 365), go to the 
      Integrations section to set up a secure credential to allow cloud sensor access to 
      the data being scanned. <br/><br/>
      Setting Up 3rd Party Credentials <br/><br/>
      Access to cloud-based data repositories will vary according to the cloud provider.<br/><br/>
      Before scans of cloud-based data can be performed, API credentials must first be 
      set up by an administrator. CYRISMA can perform cloud-based scans of Microsoft 
      365-hosted email and files and/or Google-hosted email and files.<br/><br/>
      Help for setting up API credentials for both Microsoft and Google Cloud is in the 
      Integrations section.
      </div>
      <div style={helpimg}>
      <img
        src={UIADSystem.imageUrl}
        alt={'Image of ' + UIADSystem.name}
        style={{
          width: UIADSystem.imageSize,
          borderRadius: UIADSystem.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const AD3rdparty = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Setting up 3rd Party Credentials</b><br/><br/>
      Access to cloud-based data repositories will vary according to the cloud provider. 
      The CYRISMA sensor used to scan cloud-based data is hosted by CYRISMA and located 
      in the cloud. ENCRYPTED API credential information is stored in the organization's 
      CYRISMA instance database. When a scan is performed, the cloud-based sensor will 
      retrieve the necessary credential information over a secure channel to gain access 
      to the data being scanned. The Cloud agent DOES NOT keep or maintain a copy of the 
      credential information in its local storage. <br/><br/>
      Before scans of cloud-based data can be performed, API credentials must first be 
      set up by an administrator. CYRISMA can perform cloud-based scans of Microsoft 
      365-hosted email and files and/or Google-hosted email and files. 
      </div>
      <div style={helpimg}>

      </div>
    </div>
  );
};

export const ADO365 = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Office 365 Credentials </b><br/><br/>
      To scan Microsoft Office 365-hosted email and files, you will first need to set up 
      Office 365 API credentials. <br/><br/>
      Select the “Office 365” option and fill in the form. The three values needed here 
      (Application ID, Publisher Domain and MS Client Secret Value) can be obtained by 
      logging in to the organization's Azure Portal.  <br/><br/>
      Click on the “Set up Process Guide” button and follow the steps provided in the 
      popup to complete the setup.  
      </div>
      <div style={helpimg}>
      <img
        src={UIADO365.imageUrl}
        alt={'Image of ' + UIADO365.name}
        style={{
          width: UIADO365.imageSize,
          borderRadius: UIADO365.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const ADGoogle = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Google Workspace Credentials</b><br/><br/>
      To scan Gmail and Google Drive data, you will first need to set up Google API credentials. <br/><br/>
      Select “Google” and fill in the form. <br/><br/>
      Access to Google Cloud by the CYRISMA agent is enabled via a JSON security file provided by Google.  <br/><br/>
      Click on “Set up Process Guide” and follow the steps provided in the popup to generate 
      Google’s JSON security file and complete the setup. 

      </div>
      <div style={helpimg}>
      <img
        src={UIADGoogle.imageUrl}
        alt={'Image of ' + UIADGoogle.name}
        style={{
          width: UIADGoogle.imageSize,
          borderRadius: UIADGoogle.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const ADNewregex = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Add New RegEx </b><br/><br/>
      Data Sensitivity Scans use built-in scan categories to determine what sensitivities 
      to scan for. If there are patterns of data within the scanned organization that do 
      not fit the pre-existing categories, custom regular expressions can be created using 
      the Custom RegEx entry. In addition, data sensitivity scans can scan files against a 
      keyword list. Create a keyword list of words of interest to find these among the 
      files being scanned. <br/><br/>
      The top section is for adding or updating custom regular expressions. Begin by 
      selecting the "Add New RegEx" option and fill in the form fields. <br/><br/>
      <b>Name:</b> Provide a meaningful name for this regular expression. <br/>
      <b>Description:</b> Description or purpose of this regular expression. <br/>
      <b>Score:</b> Assign a score value for each occurrence of a pattern match. Per match 
      score value is on a scale of 1 to 13, with 13 representing the highest risk. 
      Score values higher than 13 will be considered 13. This score value corresponds 
      to letter grades "A+" through "F" where 13 equals a score of "F". Scores are 
      cumulative, so a per instance string match against a RegEx with a score value 
      of 1 will require several matches per file in order for the entire file to 
      receive a failing grade. Select a score value based on anticipated pattern 
      match frequency. <br/>
      <b>RegEx:</b> The actual regular expression to match each line of text in a file against. <br/><br/>
      Submit the Regular Expression when the form is complete. When configuring a 
      data sensitivity scan, find the named, custom regular expression under the 
      "Custom" category when setting up the scan. 

      </div>
      <div style={helpimg}>
      <img
        src={UIADNewregex.imageUrl}
        alt={'Image of ' + UIADNewregex.name}
        style={{
          width: UIADNewregex.imageSize,
          borderRadius: UIADNewregex.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const ADUpdateregex = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Update or Remove Existing RegEx </b><br/><br/>
      To remove a regular expression, select “Update Existing RegEx”, and find 
      the named custom expression in the dropdown list under “Select Existing Custom RegEx”. <br/><br/>
      The details of the saved RegEx will be available in the edit window. 
      Use the DELETE button to remove the custom regular expression. 

      </div>
      <div style={helpimg}>
      <img
        src={UIADUpdateregex.imageUrl}
        alt={'Image of ' + UIADUpdateregex.name}
        style={{
          width: UIADUpdateregex.imageSize,
          borderRadius: UIADUpdateregex.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const ADKeywords = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Add or Update Keywords</b><br/><br/>
      The bottom section is for setting up or updating custom keyword lists. 
      Begin by selecting "Add New Keywords", and fill in the form fields. <br/><br/>
      <b>Name:</b> Provide a meaningful name for the list <br/>
      <b>Description:</b> Description or purpose of the keyword(s) <br/>
      <b>Score:</b> Assign a score value for each occurrence of a pattern match. Per 
      match score value is on a scale of 1 to 13, with 13 representing the highest 
      risk. Score values higher than 13 will be considered 13. This score value 
      corresponds to letter grades "A+" through "F" where 13 equals a score of "F". 
      Scores are cumulative, so a per instance string match against a keyword with 
      a score value of 1 will require several keyword matches per file in order for 
      the entire file to receive a failing grade. Select a score value based on 
      anticipated keyword hit frequency. <br/>
      <b>Keywords:</b> The list of keywords with which to match each line of text in a 
      file against. <br/><br/>
      Submit the Custom Keyword list when the form is complete. Find the named, 
      custom keyword list under the "Custom" category when setting up a data 
      sensitivity scan. <br/><br/>
      <b>Remove a keyword list</b> <br/>
      To remove a keyword list, find the named keyword list in the dropdown list 
      under "Update Existing Keywords" and submit. <br/><br/>
      The details of the saved keyword list will be available in the edit window. 
      Use the DELETE button to remove the custom keyword list. 

      </div>
      <div style={helpimg}>
      <img
        src={UIADKeywords.imageUrl}
        alt={'Image of ' + UIADKeywords.name}
        style={{
          width: UIADKeywords.imageSize,
          borderRadius: UIADKeywords.bradius,
        }}
      />
      </div>
    </div>
  );
};